var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTpsFundsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94041 9.68386L5.20817 7.41607L7.09377 9.30173L9.19837 7.19713L8.00311 6.00187H11.3364V9.3352L10.1412 8.13993L7.09377 11.1873L5.20817 9.30173L3.55873 10.9511C4.51423 12.3881 6.14806 13.3352 8.00311 13.3352C10.9486 13.3352 13.3364 10.9474 13.3364 8.00187C13.3364 5.05635 10.9486 2.66854 8.00311 2.66854C5.05757 2.66854 2.66976 5.05635 2.66976 8.00187C2.66976 8.5896 2.76482 9.15506 2.94041 9.68386ZM1.91509 10.7227L1.90834 10.7159L1.91092 10.7133C1.54168 9.88493 1.33643 8.9674 1.33643 8.00187C1.33643 4.31997 4.3212 1.33521 8.00311 1.33521C11.685 1.33521 14.6698 4.31997 14.6698 8.00187C14.6698 11.6838 11.685 14.6685 8.00311 14.6685C5.29033 14.6685 2.95601 13.0483 1.91509 10.7227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpsFundsIcon);
export default __webpack_public_path__ + "static/media/tps-funds-icon.885057b71ab56ee5b9dd020e1acc946e.svg";
export { ForwardRef as ReactComponent };